// export const ColorsTheme = [
//     ["#2680A6", "#7f00ff", "#00ffff"],
//     ['#e5d47c', '#23bcdb', '#4e1ea1'],
//     ['#79A4CB', '#A343D6', '#6965E6'],
//     ["#1A5C79", "#5900B3", "#00B3B3"],
// ]

export const ColorsTheme = [
    // Neon Cyberpunk - неоновые цвета с киберпанк эстетикой
    ["#FF006E", "#FF1A7F", "#D946A8", "#B757D1", "#8338EC", "#6B4FFF", "#4B6BFF", "#2D8FFF", "#00C8FF", "#00F5FF"],

    // Electric Garden - электрические оттенки природы
    ["#39FF14", "#5FFF33", "#85FF52", "#ABFF71", "#D1FF90", "#FF10F0", "#E636FF", "#CC5CFF", "#1E90FF", "#4DA6FF"],

    // Vibrant Pop - яркая поп-арт палитра
    ["#FF1744", "#FF4569", "#FF738E", "#FF9AA2", "#FFCB3D", "#FFEA00", "#FFE500", "#A0FF00", "#00E5FF", "#00D4FF"],

    // Sunset Fire - огненный закат
    ["#FF4500", "#FF5722", "#FF6B3D", "#FF7F50", "#FF9500", "#FFA726", "#FFB84D", "#FFC947", "#FFD700", "#FFE55C"],

    // Autumn Warmth - осеннее тепло
    ["#D2691E", "#E67E22", "#F39C12", "#F4A742", "#F5B041", "#F8C471", "#FAD7A0", "#FFD966", "#FFEB99", "#FFF4CC"],

    // Tropical Heat - тропическая жара
    ["#FF6B35", "#FF7B3F", "#FF8B49", "#FF9B53", "#FFAB5D", "#FFBB67", "#FFC971", "#FFD77B", "#FFE585", "#FFF38F"],

    // Golden Hour - золотой час
    ["#FF6F00", "#FF8F00", "#FFA000", "#FFB300", "#FFC107", "#FFD54F", "#FFE082", "#FFECB3", "#FFF9C4", "#FFFDE7"],

    // Bell Violet Rose - белый → фиолетовый → розовый
    ["#FFFFFF", "#FFF3FA", "#FFE3F6", "#F8CCFF", "#E9B1FF", "#D490FF", "#B971FF", "#9156FF", "#FF6BC1", "#FF2E9A"],

    // Oceanic Aurora - океан → бирюза → северное сияние
    ["#001B48", "#003366", "#005B96", "#0077B6", "#00A6FB", "#00C2D1", "#00E5A8", "#3DFFB5", "#A8FFEF", "#E6FFF9"],

    // Retro Wave - ретровейв (фиолетовый/магента) → персиковый → неон
    ["#2D1B69", "#3A0CA3", "#5A189A", "#7209B7", "#B5179E", "#F72585", "#FF4D6D", "#FF7A59", "#FFB703", "#FFF1A6"],

    // Midnight Neon - темная ночь → электрический синий → лайм
    ["#0B0F2B", "#101A4A", "#142B6F", "#1B44A5", "#2A6EF0", "#00B3FF", "#00E5FF", "#2DFF9D", "#B6FF3B", "#F3FF7A"],

    // Arctic Mint - ледяные пастели: мята → голубой → почти белый
    ["#052F2E", "#0B5D57", "#0E8F7E", "#2CC7B7", "#66E3D4", "#9AF3E8", "#BDEBFF", "#D7F5FF", "#EEFCFF", "#FFFFFF"],

    // Candy Sorbet - конфетный сорбет: розовый → лавандовый → голубой
    ["#FF2D95", "#FF5AB5", "#FF87CF", "#FFB3E1", "#E7B7FF", "#C7A0FF", "#9F8CFF", "#6F7BFF", "#3CCBFF", "#BFF3FF"],

    // Desert Mirage - пустынный мираж: песок → карамель → розовое небо
    ["#3B2F2F", "#6B4F3F", "#9C6B3D", "#C68642", "#E0A96D", "#F2C185", "#FFD1A1", "#FFC4B8", "#FF9FB2", "#FF6F91"],
]
